import { IApiResponse } from 'src/common/ApiResponse';
import { callApiWithFormData } from './SharedServiceFunctions';

export type UploadErrorCode = 'fileTooLarge' | 'duplicateFile' | 'uploadFailed';

export interface IUploadResult {
  documentName: string;
  documentId: string;
  success: boolean;
  fileSize: number;
  uploadErrorCode?: UploadErrorCode;
}

export class DocumentService {
  private API_URL = process.env.REACT_APP_INTERNAL_API_BASEURL;

  public async uploadDocument(file: File): Promise<IApiResponse<string>> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return await callApiWithFormData(`${this.API_URL}/documents`, formData);
  }
}

const documentService = new DocumentService();
export default documentService;
